var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"dark":"","color":"red"},on:{"click":function($event){_vm.$emit('click', $event)}}},[_vm._v("消去")])}
var staticRenderFns = []

export { render, staticRenderFns }